import React, { ReactNode } from 'react'
import { cn } from '../utils'

type Props = {
  rightSidebar?: ReactNode
  leftSidebar?: ReactNode
  main: ReactNode
  className?: string
  leftSidebarSize?: keyof typeof sidebarSizes
  rightSidebarSize?: keyof typeof sidebarSizes
  leftSidebarClassName?: string
  rightSidebarClassName?: string
  containerClassName?: string
}

const sidebarSizes = {
  '1': { sm: 'sm:w-48', md: 'md:w-48' },
  '2': { sm: 'sm:w-64', md: 'md:w-64' },
  '3': { sm: 'sm:w-80', md: 'md:w-80' },
  '4': { sm: 'sm:w-96', md: 'md:w-96' },
  '5': { sm: 'sm:w-[28rem]', md: 'md:w-[28rem]' },
} as const

export const SidebarLayout = ({
  rightSidebar,
  leftSidebar,
  main,
  leftSidebarSize = '2',
  rightSidebarSize = '2',
  leftSidebarClassName,
  rightSidebarClassName,
  containerClassName,
  ...props
}: Props) => {
  const singleSidebar = (rightSidebar || leftSidebar) && !(rightSidebar && leftSidebar)

  return (
    <div {...props} className={cn('flex flex-col gap-4 sm:gap-8 lg:flex-row lg:gap-12', containerClassName)}>
      {leftSidebar && (
        <div
          className={cn(
            'flex flex-col',
            'r-lg:flex-none',
            singleSidebar ? sidebarSizes[leftSidebarSize].sm : sidebarSizes[leftSidebarSize].md,
            leftSidebarClassName
          )}
        >
          {leftSidebar}
        </div>
      )}
      <div className="flex min-w-0 flex-col @container lg:flex-grow">{main}</div>
      {rightSidebar && (
        <div
          className={cn(
            'hidden flex-col lg:flex',
            'r-lg:flex-none',
            singleSidebar ? sidebarSizes[rightSidebarSize].sm : sidebarSizes[rightSidebarSize].md,
            rightSidebarClassName
          )}
        >
          {rightSidebar}
        </div>
      )}
    </div>
  )
}
